import { Icon } from "@iconify/react";
import { useDispatch } from "react-redux";
import {
  openConfirmToggle,
  openFormModal,
  openViewModal,
} from "../../store/reducers/talentos/talentos.reducer";
import { getTalentoByIdThunk } from "../../store/reducers/talentos/talentos.thunks";

const TalentosActions = ({ talento }) => {
  const dispatch = useDispatch();

  const handleEdit = async () => {
    // Obtener los detalles completos del talento primero
    await dispatch(getTalentoByIdThunk(talento.id));
    dispatch(
      openFormModal({
        mode: "edit",
      })
    );
  };

  const handleToggle = () => {
    dispatch(
      openConfirmToggle({
        id: talento.id,
      })
    );
  };

  const handleView = () => {
    dispatch(openViewModal());
    dispatch(getTalentoByIdThunk(talento.id));
  };

  const itemClass =
    "dropdown-item px-16 py-8 rounded d-flex align-items-center gap-2 text-secondary-light bg-hover-neutral-200 text-hover-neutral-900";

  return (
    <div className="dropdown text-center">
      <button
        type="button"
        className="btn btn-sm"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <Icon
          icon="ph:dots-three-outline-vertical-fill"
          width="20"
          className="text-neutral-700"
        />
      </button>

      <ul className="dropdown-menu p-12 border bg-base shadow">
        <li>
          <button className={itemClass} onClick={handleView}>
            <Icon icon="mdi:eye-outline" width="18" />
            <span>Ver</span>
          </button>
        </li>

        <li>
          <button className={itemClass} onClick={handleEdit}>
            <Icon icon="mdi:pencil-outline" width="18" />
            <span>Editar</span>
          </button>
        </li>

        <li>
          <button
            className={`${itemClass} ${talento.is_active ? "text-danger" : "text-success"}`}
            onClick={handleToggle}
          >
            <Icon
              icon={
                talento.is_active
                  ? "mdi:toggle-switch-off-outline"
                  : "mdi:toggle-switch-outline"
              }
              width="18"
            />
            <span>{talento.is_active ? "Desactivar" : "Activar"}</span>
          </button>
        </li>
      </ul>
    </div>
  );
};

export default TalentosActions;
